import { Box, Text } from '@hopskipdrive/react-components';
import { PageHeading } from '@rideiq/shared/components/PageHeading';

const UnauthorizedPage = () => (
  <Box display="flex" alignItems="center" flexDirection="column" mt={'32px'}>
    <PageHeading variant="h1">401 - Unauthorized access</PageHeading>{' '}
    <Text>You are not authorized to access this section of RideIQ</Text>
  </Box>
);

export default UnauthorizedPage;
